export function useCart() {
    const store = useCartStore()
    return {
        ...store,
        ...storeToRefs(store),
    }
}
